import React, { useEffect, useState } from 'react'
import Filter from "../../../../assets/Icons/filter.png";
import Download from "../../../../assets/Icons/download.png";
import { useRef } from "react";
import { useDownloadExcel } from "react-export-table-to-excel";
import leftArrow from "../../../../assets/Images/left-arrow.png";
import rightArrow from "../../../../assets/Images/right-arrow.png";
import "../saftey.css"
import "./log-incident.css"
import { DPR_API } from '../../../../services/apiCalls/dprApiCalls';
import { dateFormate } from '../../../../services/_helpers/dateFormate';
import Downloads from "../../../../assets/Icons/Download_Icon.png";
import PDF from "../../../../assets/Icons/Pdf_Icon.png";
import ExcelExport from '../../../../compnenets/commons/xls';
import Modal from 'react-responsive-modal';
import Close from "../../../../assets/Images/close.png";
import { Ascending, Descending } from '../../../../services/_helpers/sorting';

export default function LogIncidentList(props) {
  const tableRef = useRef(null);
  const [incidentList, seIncidentList] = useState([]);
  const [sortOrder, setShortOrder] = useState("ASC");
  const [sortOrderType, setShortOrderType] = useState("");
  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(true);
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "machinery resources",
    sheet: "Machinry",
  });

  const [openFilter, setOpenFilter] = useState(false);
  const onCloseFilter = () => setOpenFilter(true);
  const [filterData, setFilterData] = useState({
    "StartDate": "",
    "EndDate": "",
    "LIID": null,
    "IncidentType": "",
    "PlaceOfIncident": null
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFilterData((prev) => ({ ...prev, [name]: value }));
  };

  const getIncident = async () => {

    const inc = await DPR_API?.Get_Incidents(filterData);
    if (inc && inc?.Incident?.length) {
      seIncidentList(inc?.Incident)
    } else {
      seIncidentList([])
    }

  }

  useEffect(() => {
    getIncident();
  }, [])

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const totalPages = Math.ceil(incidentList.length / rowsPerPage);

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = incidentList.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  function truncateFileNameFromPath(fileName, maxLength) {
    const dotIndex = fileName.lastIndexOf(".");
    if (dotIndex === -1) {
      return fileName;
    }

    const name = fileName.substring(0, dotIndex);
    const extension = fileName.substring(dotIndex);

    if (fileName.length > maxLength) {
      const visibleLength = maxLength - 1 - extension.length;
      const startLength = Math.ceil(visibleLength / 2);
      const endLength = Math.floor(visibleLength / 2);
      const truncatedName = `${name.substring(
        0,
        startLength
      )}...${name.substring(name.length - endLength)}`;
      return `${truncatedName}${extension}`;
    }

    return fileName;
  }

  const handleFilterClick = async () => {
    const inc = await DPR_API.Get_Incidents(filterData);
    if (inc && inc?.Incident?.length) {
      // const sortData=sortOrder==="ASC"?Ascending(inc?.Incident,`${sortOrderType=="Incident Date"?"IncidentDate":"CreatedDate"}`):Descending(inc?.Incident,`${sortOrderType=="Incident Date"?"IncidentDate":"CreatedDate"}`);
      seIncidentList(inc?.Incident)
    } else {
      seIncidentList([])
    }
    setOpenFilter(false)
  };
  // Ascending
  const handleClear = async () => {
    let data = {
      "StartDate": "",
      "EndDate": "",
      "LIID": null,
      "IncidentType": "",
      "PlaceOfIncident": null
    };
    setCurrentPage(1)
    setFilterData(data);
    const inc = await DPR_API.Get_Incidents(data);
    if (inc && inc?.Incident?.length) {
      seIncidentList(inc?.Incident)
    } else {
      seIncidentList([])
    }
  }
  useEffect(()=>{
      props.setUpdateDate(null)
    },[])

  return <React.Fragment>
    <div className="row">
      <div className="d-flex justify-content-end">
        <div className="download-icon">
          <ExcelExport data={incidentList} fileName="incident" sheet="incident" />
        </div>
        <div className="filter-icon mx-2 my-auto">
          <img
            className=""
            onClick={() => {
              setOpenFilter(true);
            }}
            src={Filter}
            width={20}
          />
        </div>
        <div className="my-auto">
          <span style={{ cursor: "pointer", fontSize: 12, fontWeight: 500, background: "#8add79f7", padding: 5, borderRadius: 12 }} onClick={handleClear}>Clear filters</span>
        </div>
      </div>
    </div>
    <div className="table-container">
      <table id="custom-table-archival">
        <thead className="table-header-archival">
          <tr>
            <th>S.No</th>
            <th>Project Name</th>
            <th>LI ID</th>
            <th>Incident Date</th>
            <th>Place of incident</th>
            <th>Place/Activity type</th>
            <th>Incident Type</th>
            <th>Attachment</th>
            <th>Incident photograph</th>
          </tr>
        </thead>
        <tbody>
          {paginatedData.map((row, index) => (
            <tr key={index} onClick={()=>{
              props.setUpdateDate(row)
              props?.setSelectedIndex(1)
            }}>
              <td>{index + 1}</td>

              <td
                style={{
                  color: "rgb(102 104 106)",
                  fontSize: 14,
                  fontWeight: 500,
                }}
              >
                {row?.ProjectName}
              </td>
              <td
                style={{
                  color: "rgb(102 104 106)",
                  fontSize: 14,
                  fontWeight: 500,
                }}
              >
                {row?.LIID}
              </td>
              <td
                style={{
                  color: "rgb(102 104 106)",
                  fontSize: 14,
                  fontWeight: 500,
                }}
              >
                {dateFormate(row?.IncidentDate, "DD-MM-YYYY")}
              </td>
              <td
                style={{
                  color: "rgb(102 104 106)",
                  fontSize: 14,
                  fontWeight: 500,
                }}
              >
                {row?.PlaceOfIncident}
              </td>
              <td
                style={{
                  color: "rgb(102 104 106)",
                  fontSize: 14,
                  fontWeight: 500,
                }}
              >
                {row?.PlaceActivityType}
              </td>
              <td
                style={{
                  color: "rgb(102 104 106)",
                  fontSize: 14,
                  fontWeight: 500,
                }}
              >
                {row?.IncidentType}
              </td>
              <td>
                <div className='d-flex justify-content-between'>
                  <div>
                    <img src={PDF} width={12} />
                  </div>
                  <div className='my-auto'>
                    {truncateFileNameFromPath(
                      decodeURIComponent(row?.Attachment?.split("/").pop()),
                      12
                    )}
                    {/* {row?.ComplianceEvidence} */}
                  </div>
                  <div>
                    <img src={Downloads} width={12} style={{ cursor: "pointer" }}
                      onClick={() => {
                        const link = document.createElement("a");
                        link.href = row?.Attachment;
                        console.log(row?.Attachment?.split("/").pop());
                        link.setAttribute("download", row?.Attachment?.split("/").pop());
                        // link.download = decodeURIComponent(fileUrl?.split('/').pop());
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                      }}
                    />
                  </div>
                </div>
              </td>
              <td>
                <div className='d-flex justify-content-between'>
                  <div>
                    <img src={PDF} width={12} />
                  </div>
                  <div className='my-auto'>
                    {truncateFileNameFromPath(
                      decodeURIComponent(row?.IncidentSitePhotograph?.split("/").pop()),
                      12
                    )}
                    {/* {row?.ComplianceEvidence} */}
                  </div>
                  <div>
                    <img src={Downloads} width={12} style={{ cursor: "pointer" }}
                      onClick={() => {
                        const link = document.createElement("a");
                        link.href = row?.IncidentSitePhotograph;
                        console.log(row?.IncidentSitePhotograph?.split("/").pop());
                        link.setAttribute("download", row?.IncidentSitePhotograph?.split("/").pop());
                        // link.download = decodeURIComponent(fileUrl?.split('/').pop());
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                      }}
                    />
                  </div>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    <div
      className="pagination"
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px 15px",
      }}
    >
      <div style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
        Showing{" "}
        {Math.min((currentPage - 1) * rowsPerPage + 1, incidentList.length)} to{" "}
        {Math.min(currentPage * rowsPerPage, incidentList.length)} of{" "}
        {incidentList.length} entries
      </div>
      <div
        className="pagination-buttons"
        style={{
          fontSize: "14px",
          display: "flex",
          justifyContent: "flex-end",
          width: "100%",
          gap: "5px",
        }}
      >
        {/* Left Arrow */}
        <button
          onClick={() => handleClick(Math.max(1, currentPage - 1))}
          disabled={currentPage === 1}
          style={{
            background: "none",
            border: "none",
            cursor: currentPage === 1 ? "not-allowed" : "pointer",
          }}
        >
          <img
            src={leftArrow} // Replace with your actual image path
            alt="Previous"
            height="11px"
            width="7px"
            style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
          />
        </button>

        {/* Page Numbers */}
        {[...Array(totalPages)].map((_, i) => (
          <button
            key={i}
            onClick={() => handleClick(i + 1)}
            style={{
              background: currentPage === i + 1 ? "#00B69B" : "transparent",
              color: currentPage === i + 1 ? "#fff" : "#000",
              border: "none",
              borderRadius: "50%",
              width: "30px",
              height: "30px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
          >
            {i + 1}
          </button>
        ))}

        {/* Right Arrow */}
        <button
          onClick={() => handleClick(Math.min(totalPages, currentPage + 1))}
          disabled={currentPage === totalPages}
          style={{
            background: "none",
            border: "none",
            cursor: currentPage === totalPages ? "not-allowed" : "pointer",
          }}
        >
          <img
            src={rightArrow} // Replace with your actual image path
            alt="Next"
            height="11px"
            width="7px"
            style={{ opacity: currentPage === totalPages ? 0.5 : 1 }}
          />
        </button>
      </div>
    </div>

    <Modal open={openFilter} onClose={onCloseFilter} center>
      <div className="d-flex justify-content-between">
        <div>
          <span className="resources">Log Observation Filter</span>
        </div>
        <div>
          <img
            src={Close}
            width={20}
            onClick={() => setOpenFilter(false)}
            style={{ cursor: "pointer" }}
          />
        </div>
      </div>
      <hr />
      <div className="row">
        <div className="card mt-0 card-bd-none">
          <div className="card-body">
            <div className="row mt-1">
              <div className="col-6">
                <label className="filter-label">Start Date</label>
                <input
                  type="date"
                  name="StartDate"
                  value={filterData.StartDate}
                  onChange={handleChange}
                  className="form-control shadow-none"
                />
              </div>
              <div className="col-6">
                <label className="filter-label">End Date</label>
                <input
                  type="date"
                  name="EndDate"
                  value={filterData.EndDate}
                  onChange={handleChange}
                  className="form-control shadow-none"
                />
              </div>
            </div>

            <div className="row mt-1">
              <div className="col-6">
                <label className="filter-label">LI ID</label>
                <input
                  type="text"
                  name="LOID"
                  value={filterData.LIID}
                  onChange={handleChange}
                  className="form-control shadow-none"
                />
              </div>
              <div className="col-6">
                <label className="filter-label">Incident Type</label>
                <select onChange={handleChange} value={filterData?.IncidentType} name='IncidentType' style={{
                  width: "100%",
                  height: 31,
                  border: "1px solid #e6e3e3",
                  borderRadius: 4,
                  color: 'gray',
                  fontSize: 13,
                  paddingLeft: 10
                }}>
                  <option value={""}>--Select--</option>
                  <option value={"First Aid"}>First Aid</option>
                  <option value={"Equipment Propert Damage"}>Equipment Propert Damage</option>
                  <option value={"Fatality"}>Fatality</option>
                  <option value={"Fire"}>Fire</option>
                  <option value={"Derailment"}>Derailment</option>
                  <option value={"LTI"}>LTI</option>
                  <option value={"Near Miss"}>Near Miss</option>
                  <option value={"Toxic Release"}>Toxic Release</option>
                </select>
              </div>
            </div>
            <div className='row'>
              <label className='label-custom'>Place of incident</label>
              <select onChange={handleChange} value={filterData?.PlaceOfIncident} name='PlaceOfIncident' style={{
                width: "100%",
                height: 31,
                border: "1px solid #e6e3e3",
                borderRadius: 4,
                color: 'gray',
                fontSize: 13,
                paddingLeft: 10
              }}>
                <option value={""}>--Select--</option>
                <option value={"Workplace"}>Workplace</option>
                <option value={"Place of Incident"}>Place of Incident</option>
              </select>
            </div>

          </div>
        </div>
      </div>
      <div className="row mt-3">
        <div className="d-flex justify-content-between">
          <div style={{ marginLeft: 20 }}>
            <span className="resorces">Sort Log Observation</span>
          </div>
          <div style={{ marginRight: 20 }}>
            <select
              name="sortOrder"
              value={sortOrder}
              onChange={(e)=>{
                setShortOrder(e.target.value)
              }}
              className="filter-label"
              style={{
                width: "100%",
                height: 31,
                border: "1px solid #e6e3e3",
                borderRadius: 4,
              }}
            >
              <option value="ASC">ASC</option>
              <option value="DES">DES</option>
            </select>
          </div>
        </div>
      </div>
      <div className="row" style={{ marginLeft: 20 }}>
        {[
          "Incident Date",
          "Created date"
        ].map((sortOption) => (
          <div className="form-check" key={sortOption}>
            <input
              className="form-check-input shadow-none"
              type="radio"
              name="sortBy"
              id={sortOption}
              value={sortOption}
              // checked={sortOrderType}
              checked={sortOrderType==sortOption}
              onChange={(e)=>{
                setShortOrderType(sortOption)
              }}
            />
            <label htmlFor={sortOption} style={{ fontSize: 14 }}>
              {sortOption}
            </label>
          </div>
        ))}
      </div>

      <div className="d-flex justify-content-center mt-4 pb-4">
        <button
          className="btn btn-primary"
          onClick={handleFilterClick}
        >
          Filter
        </button>
      </div>
    </Modal>

  </React.Fragment>
}
